import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  login,
  register,
  verifyEmail,
  verifyToken,
} from "../services/authService";
import { TOKEN_KEY } from "../../constants";
import { useNavigate } from "react-router-dom";

export const useVerifyToken = () => {
  return useQuery({
    queryKey: ["account"],
    queryFn: verifyToken,
  });
};

export const useRegister = () => {
  return useMutation({
    mutationFn: register,
    onError: (error: Error) => {
      console.error("Registration failed:", error.message);
    },
  });
};

export const useVerifyEmail = () => {
  return useMutation({
    mutationFn: verifyEmail,
    onSuccess: (data) => {
      localStorage.setItem(TOKEN_KEY, data.token);
    },
    onError: (error: Error) => {
      console.error("Email verification failed:", error.message);
    },
  });
};

export const useLogin = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      localStorage.setItem(TOKEN_KEY, data.token);
      queryClient.invalidateQueries({ queryKey: ["account"] });
      navigate("/", { replace: true });
    },
    onError: (error: Error) => {
      console.error("login failed:", error.message);
    },
  });
};
